function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import deepFreeze from 'deep-freeze-strict';
import qs from 'qs';
import _ from 'lodash/fp';

var fp = _.noConflict(); // The default 'matching' ordering is a bit complex since it depends on the type of element,
// the number of elements and if is a distance query or not.


function matchingOrder(n, asc) {
  var range = fp.range(0, n);
  return [].concat(_toConsumableArray(fp.map(function (i) {
    return {
      field: "l.unit".concat(i + 1),
      asc: asc,
      type: 'units',
      side: 'left',
      element: i
    };
  })(range)), _toConsumableArray(fp.map(function (i) {
    return {
      field: "r.unit".concat(i + 1),
      asc: asc,
      type: 'units',
      side: 'right',
      element: i
    };
  })(range)), _toConsumableArray(fp.map(function (i) {
    return {
      field: "l.token".concat(i + 1),
      asc: asc,
      type: 'tokens',
      side: 'left',
      element: i
    };
  })(range)), _toConsumableArray(fp.map(function (i) {
    return {
      field: "r.token".concat(i + 1),
      asc: asc,
      type: 'tokens',
      side: 'right',
      element: i
    };
  })(range)), _toConsumableArray(fp.map(function (i) {
    return {
      field: "l.tag".concat(i + 1),
      asc: asc,
      type: 'tokens',
      side: 'left',
      element: i
    };
  })(range)), _toConsumableArray(fp.map(function (i) {
    return {
      field: "r.tag".concat(i + 1),
      asc: asc,
      type: 'tokens',
      side: 'right',
      element: i
    };
  })(range)), _toConsumableArray(fp.map(function (i) {
    return {
      field: "l.lemma".concat(i + 1),
      asc: asc,
      type: 'tokens',
      side: 'left',
      element: i
    };
  })(range)), _toConsumableArray(fp.map(function (i) {
    return {
      field: "r.lemma".concat(i + 1),
      asc: asc,
      type: 'tokens',
      side: 'right',
      element: i
    };
  })(range)));
}

function elementFieldOrder(n, asc, type, field) {
  return fp.map(function (i) {
    return {
      name: "".concat(field).concat(i + 1),
      criteria: [{
        field: "l.".concat(field).concat(i + 1),
        side: 'left',
        element: i,
        asc: asc,
        type: type
      }, {
        field: "r.".concat(field).concat(i + 1),
        side: 'right',
        element: i,
        asc: asc,
        type: type
      }]
    };
  })(fp.range(0, n));
}

function nextElementsOrder(n) {
  return fp.map(function (i) {
    return {
      name: "next_".concat(i + 1),
      criteria: [{
        field: "r".concat(i + 1, ".unit1"),
        asc: true,
        type: 'units'
      }, {
        field: "r".concat(i + 1, ".token1"),
        asc: true,
        type: 'tokens'
      }]
    };
  })(fp.range(0, 2));
}

function previousElementsOrder(n) {
  return fp.map(function (i) {
    return {
      name: "previous_".concat(i + 1),
      criteria: [{
        field: "l-".concat(i + 1, ".unit1"),
        asc: true,
        type: 'units'
      }, {
        field: "l-".concat(i + 1, ".token1"),
        asc: true,
        type: 'tokens'
      }]
    };
  })(fp.range(0, 2));
}

function defaultOrder() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  return [{
    name: 'matching',
    criteria: matchingOrder(n, true)
  }].concat(_toConsumableArray(nextElementsOrder(2)), _toConsumableArray(previousElementsOrder(2)), _toConsumableArray(elementFieldOrder(n, true, 'units', 'unit')), _toConsumableArray(elementFieldOrder(n, true, 'tokens', 'token')), _toConsumableArray(elementFieldOrder(n, true, 'tokens', 'tag')), _toConsumableArray(elementFieldOrder(n, true, 'tokens', 'lemma')), _toConsumableArray(elementFieldOrder(n, true, 'tokens', 'unit')));
}

export default {
  matchingOrder: matchingOrder,
  nextElementsOrder: nextElementsOrder,
  previousElementsOrder: previousElementsOrder,
  elementFieldOrder: elementFieldOrder,
  defaultOrder: defaultOrder,
  // Merge new config values with defaults.
  mergeConfig: function mergeConfig(defaultConfig, config) {
    // If provided value is an array, replace the default value instead of merging.
    var merged = fp.mergeWith(function (v, sv) {
      return fp.isArray(v) ? sv : undefined;
    })(defaultConfig)(config);
    return deepFreeze(merged);
  },
  // https://github.com/ljharb/qs/issues/91#issuecomment-437926409
  decoder: function decoder(str) {
    var strWithoutPlus = str.replace(/\+/g, ' ');

    if (/^(\d+|\d*\.\d+)$/.test(str)) {
      return parseFloat(str);
    }

    var keywords = {
      "true": true,
      "false": false,
      "null": null,
      undefined: undefined
    };

    if (str in keywords) {
      return keywords[str];
    }

    try {
      return decodeURIComponent(strWithoutPlus);
    } catch (e) {
      return strWithoutPlus;
    }
  },
  parseQuery: function parseQuery(querystring, _state) {
    return qs.parse(querystring, {
      skipNulls: true,
      decoder: decoder
    });
  },
  stringifyQuery: function stringifyQuery(querystring, _state) {
    return qs.stringify(querystring, {
      skipNulls: true
    });
  }
};